module.exports = __webpack_public_path__ + "img/zu2.551a4182.png";